import React, { useContext } from 'react';
import { Box, Button, Typography, alpha, useTheme } from '@mui/material';
import { InputContext } from '../chat-input';

const InputLinearLoading = () => {
    const theme = useTheme();
    const inputHook = useContext(InputContext);
    const { onResend, onCancel, onEdit } = inputHook!;

    return (
        <Box
            sx={{
                mb: 0.75,
                px: 1.25,
                py: 0.75,
                borderRadius: 2,
                bgcolor: alpha(theme.palette.error.main, theme.palette.mode === 'dark' ? 0.12 : 0.07),
                display: 'flex',
                alignItems: { xs: 'flex-start', sm: 'center' },
                justifyContent: 'space-between',
                gap: 1,
                flexWrap: 'wrap',
            }}>
            <Typography variant="caption" sx={{ color: 'error.main' }}>
                پیام ارسال نشد. دوباره تلاش کنید.
            </Typography>
            <Box sx={{ display: 'flex', gap: 0.5 }}>
                <Button size="small" onClick={onResend}>تلاش دوباره</Button>
                {onEdit && <Button size="small" onClick={onEdit}>ویرایش</Button>}
                <Button size="small" color="inherit" onClick={onCancel}>لغو</Button>
            </Box>
        </Box>
    );
};

export default InputLinearLoading;
